var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"am-control"},[_c('am-button-icon',{staticClass:"am-control__prev",attrs:{"name":"arrow-left"},on:{"click":function($event){return _vm.$emit('prev', $event)}}}),_c('am-button-icon',{staticClass:"am-control__next",attrs:{"name":"arrow-right"},on:{"click":function($event){return _vm.$emit('next', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }